module.exports = __webpack_public_path__ + "assets/bdc1d0a380694735d622f6a204d45075.png";